// source: dbApiInfo.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.common.model.DbApiInfo', null, global);
goog.exportSymbol('proto.common.model.DbApiList', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.model.DbApiInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.model.DbApiInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.model.DbApiInfo.displayName = 'proto.common.model.DbApiInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.model.DbApiList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.common.model.DbApiList.repeatedFields_, null);
};
goog.inherits(proto.common.model.DbApiList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.model.DbApiList.displayName = 'proto.common.model.DbApiList';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.model.DbApiInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.common.model.DbApiInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.model.DbApiInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.model.DbApiInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
apiid: jspb.Message.getFieldWithDefault(msg, 1, ""),
apikey: jspb.Message.getFieldWithDefault(msg, 2, ""),
apisecret: jspb.Message.getFieldWithDefault(msg, 3, ""),
passphrase: jspb.Message.getFieldWithDefault(msg, 4, ""),
exchangeid: jspb.Message.getFieldWithDefault(msg, 5, 0),
creator: jspb.Message.getFieldWithDefault(msg, 6, ""),
createms: jspb.Message.getFieldWithDefault(msg, 7, 0),
deleted: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
enableproxy: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.model.DbApiInfo}
 */
proto.common.model.DbApiInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.model.DbApiInfo;
  return proto.common.model.DbApiInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.model.DbApiInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.model.DbApiInfo}
 */
proto.common.model.DbApiInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setApiid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setApikey(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setApisecret(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassphrase(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setExchangeid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreator(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatems(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDeleted(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEnableproxy(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.model.DbApiInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.model.DbApiInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.model.DbApiInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.model.DbApiInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApiid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getApikey();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getApisecret();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPassphrase();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getExchangeid();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getCreator();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCreatems();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getDeleted();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getEnableproxy();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
};


/**
 * optional string apiId = 1;
 * @return {string}
 */
proto.common.model.DbApiInfo.prototype.getApiid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.DbApiInfo} returns this
 */
proto.common.model.DbApiInfo.prototype.setApiid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string apiKey = 2;
 * @return {string}
 */
proto.common.model.DbApiInfo.prototype.getApikey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.DbApiInfo} returns this
 */
proto.common.model.DbApiInfo.prototype.setApikey = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string apiSecret = 3;
 * @return {string}
 */
proto.common.model.DbApiInfo.prototype.getApisecret = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.DbApiInfo} returns this
 */
proto.common.model.DbApiInfo.prototype.setApisecret = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string passphrase = 4;
 * @return {string}
 */
proto.common.model.DbApiInfo.prototype.getPassphrase = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.DbApiInfo} returns this
 */
proto.common.model.DbApiInfo.prototype.setPassphrase = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 exchangeId = 5;
 * @return {number}
 */
proto.common.model.DbApiInfo.prototype.getExchangeid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.model.DbApiInfo} returns this
 */
proto.common.model.DbApiInfo.prototype.setExchangeid = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string creator = 6;
 * @return {string}
 */
proto.common.model.DbApiInfo.prototype.getCreator = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.DbApiInfo} returns this
 */
proto.common.model.DbApiInfo.prototype.setCreator = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int64 createMs = 7;
 * @return {number}
 */
proto.common.model.DbApiInfo.prototype.getCreatems = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.model.DbApiInfo} returns this
 */
proto.common.model.DbApiInfo.prototype.setCreatems = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional bool deleted = 8;
 * @return {boolean}
 */
proto.common.model.DbApiInfo.prototype.getDeleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.model.DbApiInfo} returns this
 */
proto.common.model.DbApiInfo.prototype.setDeleted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional int32 enableProxy = 9;
 * @return {number}
 */
proto.common.model.DbApiInfo.prototype.getEnableproxy = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.model.DbApiInfo} returns this
 */
proto.common.model.DbApiInfo.prototype.setEnableproxy = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.common.model.DbApiList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.model.DbApiList.prototype.toObject = function(opt_includeInstance) {
  return proto.common.model.DbApiList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.model.DbApiList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.model.DbApiList.toObject = function(includeInstance, msg) {
  var f, obj = {
apisList: jspb.Message.toObjectList(msg.getApisList(),
    proto.common.model.DbApiInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.model.DbApiList}
 */
proto.common.model.DbApiList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.model.DbApiList;
  return proto.common.model.DbApiList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.model.DbApiList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.model.DbApiList}
 */
proto.common.model.DbApiList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.common.model.DbApiInfo;
      reader.readMessage(value,proto.common.model.DbApiInfo.deserializeBinaryFromReader);
      msg.addApis(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.model.DbApiList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.model.DbApiList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.model.DbApiList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.model.DbApiList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApisList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.common.model.DbApiInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated DbApiInfo apis = 1;
 * @return {!Array<!proto.common.model.DbApiInfo>}
 */
proto.common.model.DbApiList.prototype.getApisList = function() {
  return /** @type{!Array<!proto.common.model.DbApiInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.common.model.DbApiInfo, 1));
};


/**
 * @param {!Array<!proto.common.model.DbApiInfo>} value
 * @return {!proto.common.model.DbApiList} returns this
*/
proto.common.model.DbApiList.prototype.setApisList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.common.model.DbApiInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.model.DbApiInfo}
 */
proto.common.model.DbApiList.prototype.addApis = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.common.model.DbApiInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.common.model.DbApiList} returns this
 */
proto.common.model.DbApiList.prototype.clearApisList = function() {
  return this.setApisList([]);
};


goog.object.extend(exports, proto.common.model);
